import { z } from 'zod';
import { ID_DOCUMENT_TYPES } from '../constants/index.js';

const StorageKey = z
  .string()
  .min(1, 'kyc.storageKey.required')
  // Path layout enforced by spec §7: {user_id}/{submission_id}/{selfie|id}.jpg
  // We accept jpg/png/webp to match the bucket allowed_mime_types.
  .regex(
    /^[0-9a-f-]{36}\/[0-9a-f-]{36}\/(selfie|id)\.(jpg|jpeg|png|webp)$/i,
    'kyc.storageKey.shape',
  );

export const KycSubmitSchema = z.object({
  id_document_type: z.enum(ID_DOCUMENT_TYPES),
  id_document_storage_key: StorageKey,
  selfie_storage_key: StorageKey,
  /** Optional: link this submission to the transfer that triggered KYC. */
  transfer_id: z.string().uuid().optional(),
});
export type KycSubmitInput = z.infer<typeof KycSubmitSchema>;

export const KycDecideSchema = z
  .object({
    submission_id: z.string().uuid(),
    decision: z.enum(['approved', 'rejected']),
    rejection_reason: z.string().trim().min(3).max(500).optional(),
  })
  .refine((v) => v.decision !== 'rejected' || !!v.rejection_reason, {
    message: 'kyc.rejectionReason.required',
    path: ['rejection_reason'],
  });
export type KycDecideInput = z.infer<typeof KycDecideSchema>;
